import React from 'react'
import ReviewFeaturebox1 from './Review-Feature-box1'
// import CardFeaturebox2 from './Card-Feature-box2'
function ReviewFeature() {
    return (
        <>
            <ReviewFeaturebox1 />
        </>
    )
}

export default ReviewFeature